import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import bowser from 'yola-bowser';
import noop from '../utils/noop';
import { iconsList } from '../icon/glyphs';
import Icon from '../icon';
import Render from '../render';

function MenuItem({
  type = 'default',
  icon = null,
  active = false,
  onClick = noop,
  onMouseEnter = noop,
  onMouseLeave = noop,
  className = null,
  children = null,
  href = null,
  disabled = false,
  target = '_self',
  ...otherProps
}) {
  const isMobile = bowser.mobile || bowser.tablet;
  const menuItemClass = classNames('ws-menu-item', className, {
    'ws-menu-item--divider': type === 'divider',
    'ws-menu-item--active': active,
    'ws-menu-item--mobile': isMobile,
    'ws-menu-item--disabled': disabled,
  });

  if (type === 'divider') {
    return <li className={menuItemClass} {...otherProps} />;
  }

  return (
    <li
      className={menuItemClass}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      {...otherProps}
    >
      <Render if={Boolean(icon)}>
        <Icon className="ws-menu-item__icon" glyph={icon} />
      </Render>
      <Render if={!href}>{children}</Render>
      <Render if={Boolean(href)}>
        <a className="ws-menu-item--link" {...otherProps} href={href} target={target}>
          {children}
        </a>
      </Render>
    </li>
  );
}

MenuItem.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.oneOf(iconsList),
  type: PropTypes.oneOf(['default', 'divider']),
  active: PropTypes.bool,
  onClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  children: PropTypes.node,
  href: PropTypes.string,
  target: PropTypes.string,
  disabled: PropTypes.bool,
};

export default MenuItem;
